export const elementAtOrDefault = async (source, index) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const values = await dataFunc.generator();
            if (index >= values.length) {
                return null;
            }
            else {
                return values[index];
            }
        }
        case 1: {
            const promises = dataFunc.generator();
            if (index >= promises.length) {
                return null;
            }
            else {
                return await promises[index];
            }
        }
        case 2: {
            const promises = await dataFunc.generator();
            if (index >= promises.length) {
                return null;
            }
            else {
                return await promises[index];
            }
        }
    }
};
